<template>
    <vs-textarea @blur="checkComment" v-model="comment"/>
</template>

<script>
export default{
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
          comment: '',
        }
    },
    methods: {
      checkComment(){
        if (this.comment !== this.item.comment){
          const thisIns = this;
          this.$vs.loading();

          axios.post(apiUrl+'/order/'+this.item.intId+'/change/comment?token='+token, {comment : this.comment})
            .then(function (response) {

              let data = response.data;
              if(data.code === 200){
                thisIns.item.comment = thisIns.comment;
              }else{
                if (data.code === 401){
                  window.logout();
                }
                thisIns.$vs.notify({
                  title: 'Error',
                  text:  data.message,
                  color: 'danger',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                });
              }
              thisIns.$vs.loading.close();
            });
        }
      },
    },
    created() {
      this.comment = this.item.comment;
    }
}
</script>

<style lang="scss" scoped>

</style>
